<template>
  <v-navigation-drawer
    persistent
    v-model="drawer"
    fixed
    app
    color="secondary"
    :width="370"
    mobile-breakpoint="0"
  >
    <div class=" px-10 mt-16">
      <img width="200" :src="$images.LOGO_WHITE" class="mt-16 mb-8" />
      <img :src="$images.INVITE_TEXT" width="300" class="mb-8" />
      <img :src="$images.STAR_ICON" width="25" class="mb-8" />
      <div class="text-h5 white--text font-weight-medium">
        CoreCounts promise
      </div>
      <div class="text-h6 white--text font-weight-light half-opacity">
        We promise to provide you with the tools and resources necessary to
        drive your companies culture in a direction that benefits everyone!
      </div>
      <v-img
        :src="$images.REGISTRATION_ILLUSTRATION"
        width="300"
        class="decorative"
      ></v-img>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "RegistrationNavigationDrawer",
  components: {},
  data: () => ({ drawer: true })
};
</script>

<style lang="scss" scoped>
.decorative {
  position: absolute;
  bottom: 0;
  left: 0;
}

.half-opacity {
  opacity: 0.5;
}
</style>
